// extracted by mini-css-extract-plugin
export default {"container":"SignUpModal_container__yZFbw","title":"SignUpModal_title__F+6z-","textField":"SignUpModal_textField__H2adP","googleIcon":"SignUpModal_googleIcon__LTJ4x"};